import { css } from "emotion/macro"
import { color, mq } from "../../styles/variables"

export const eventsCalendar = css`
  margin-top: 60px;
  margin-bottom: 60px;

  .notice {
    text-align: center;
    padding: 30px;
    background-color: ${color.rgba.purple(0.1)[1]};
    margin-bottom: 30px;
    color: ${color.rgb.black[1]};
    font-weight: bold;
  }

  h1 {
    text-align: center;
  }

  .search-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;

    input {
      padding: 5px 10px;
      font-size: 14px;
    }
  }

  .btn-wrapper {
    align-self: center;
  }

  .calendar-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > button {
      font-size: 1rem;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
      color: ${color.rgb.purple[1]};
      text-decoration: underline;

      &:focus {
        outline: 1px soild ${color.rgba.orange(0.15)[0]};
      }
    }

    .calendar-wrapper-inner {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 10;
    }
  }

  .filters {
    background-color: ${color.rgba.purple(0.06)[1]};
    padding: 15px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: -0.02px;
    color: #333333;

    > div {
      margin-top: 10px;
    }

    .input-wrapper,
    .field-group {
      width: 100%;
      max-width: 100%;
      min-width: auto;
    }

    .search-wrapper {
      position: relative;

      .search-icon {
        position: absolute;
        bottom: 5px;
        left: 0;

        svg {
          width: 11px;
          height: 11px;

          path {
            fill: #9b9b9c;
          }
        }
      }

      input {
        background: transparent;
        padding: 4px 18px;
        border: none;
        border-bottom: 1px dashed #9b9b9c;

        &:focus {
          outline: none;
          border-bottom: 1px solid ${color.rgb.orange[0]};
        }
      }
    }

    .reset-wrapper {
      button {
        color: ${color.rgb.orange[0]};
        display: inline-flex;
        text-transform: uppercase;
        align-items: center;
        padding: 10px 0;
        background: none;
        border: none;
        font-weight: 600;

        &:hover,
        &:focus {
          cursor: pointer;
          outline: 1px solid ${color.rgba.orange(0.15)[0]};
        }

        svg {
          padding-right: 5px;
          width: 12px;
          path {
            fill: ${color.rgb.orange[0]};
          }
        }
      }
    }

    ${mq.md(css`
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 15px;

      > div {
        &.topic-wrapper,
        &.venue-wrapper {
          margin-left: 20px;
        }

        &.month-wrapper {
          width: 18%;
        }

        &.topic-wrapper {
          width: calc(27% + 20px);
        }

        &.venue-wrapper {
          width: calc(34% + 20px);
        }

        &.search-wrapper,
        &.reset-wrapper {
          margin-top: 20px;
        }

        &.search-wrapper {
          width: 80%;
        }

        &.reset-wrapper {
          width: 100%;
          text-align: center;
        }
      }
    `)};

    ${mq.lg(css`
      > div {
        margin-top: 0;

        &.topic-wrapper,
        &.venue-wrapper,
        &.search-wrapper,
        &.reset-wrapper {
          margin-top: 0;
          margin-left: 20px;
        }

        &.month-wrapper {
          width: 14%;
        }

        &.topic-wrapper {
          width: 17%;
        }

        &.venue-wrapper {
          width: 21%;
        }

        &.search-wrapper {
          width: 22%;
        }

        &.reset-wrapper {
          width: auto;
          text-align: right;
          margin-top: 10px;
          flex-grow: 2;
          margin-right: 15px;
        }
      }
    `)};
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/EventsCalendar/style.js